class Subnavigation extends BaseSlider {
  constructor() {
    super();
    this.swiperInstance = null;
    this.initialSlideIndex = this.getAttribute('data-initialSlide');
  }

  connectedCallback() {
    this.initSubnavigation();
  }

  initSubnavigation() {
    this.swiperInstance = new Swiper(this, {
      spaceBetween: 24,
      loop: false,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      init: true,
      observer: true,
      slidesPerView: 'auto',
      observeParents: true,
      on: {
        init: function () {
          this?.el?.classList.remove('opacity-0');
          this?.wrapperEl?.classList.remove(
            'items-center',
            'justify-center',
            'gap-4'
          );
        },
      },
      watchOverflow: true,
      initialSlide: this.initialSlideIndex,
    });
  }
}

customElements.define('sub-navigation', Subnavigation);
